import implant from '../../assets/service/implant.webp';
import bridge from '../../assets/service/bridge.webp';
import crown from '../../assets/service/crown.webp';
import dentures from '../../assets/service/dentures.webp';
import fillings from '../../assets/service/filling.webp';
import abscess from '../../assets/service/abscess.webp';
import toothache from '../../assets/service/toothache.webp';
import wisdom from '../../assets/service/wisdom.webp'; 
import whitening from '../../assets/service/whitening.webp';
import cleaning from '../../assets/service/cleaning.webp';

const ServicesData = [
    // Preventive Care
    {
        'icon': cleaning,
        'title': 'Cleaning',
        'description': 'Deep cleaning and scaling treatments for advanced gum disease.',
        'category': 'Preventive Care'
    },
    
    // Restorative Dentistry
    {
        'icon': implant,
        'title': 'Dental Implant',
        'description': 'Permanent tooth replacement solution that looks and feels like natural teeth.',
        'category': 'Specialized Treatments'
    },
    {
        'icon': bridge,
        'title': 'Bridges',
        'description': 'Fixed dental bridges to replace missing teeth and restore your smile.',
        'category': 'Restorative Dentistry'
    },
    {
        'icon': crown,
        'title': 'Crowns',
        'description': 'Custom-made dental crowns to protect and restore damaged teeth.',
        'category': 'Restorative Dentistry'
    },
    {
        'icon': dentures,
        'title': 'Partial and Full Dentures',
        'description': 'Removable prosthetic devices to replace missing teeth and restore function.',
        'category': 'Restorative Dentistry'
    },
    {
        'icon': fillings,
        'title': 'Fillings',
        'description': 'Tooth-colored fillings to repair cavities and restore tooth structure.',
        'category': 'Restorative Dentistry'
    },
    
    // Emergency & Pain Relief
    {
        'icon': abscess,
        'title': 'Dental Abscess',
        'description': 'Treatment for dental abscesses to relieve pain and prevent infection spread.',
        'category': 'Emergency & Pain Relief'
    },
    {
        'icon': toothache,
        'title': 'Toothaches',
        'description': 'Emergency pain relief and treatment for various toothache causes.',
        'category': 'Emergency & Pain Relief'
    },
    
    // Specialized Treatments
    {
        'icon': wisdom,
        'title': 'Wisdom Teeth',
        'description': 'Wisdom tooth extraction and management for impacted or problematic teeth.',
        'category': 'Specialized Treatments'
    },
    {
        'icon': whitening,
        'title': 'Whitening',
        'description': 'Professional teeth whitening treatments for a brighter, more confident smile.',
        'category': 'Specialized Treatments'
    }
];

export default ServicesData;